import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import clsx from 'clsx';
import { createFilterOptions, Autocomplete as MuiAutocomplete, InputAdornment, Typography, ListItem, } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import GenericInput from '../../genericInput/GenericInput';
import autocompleteStyles from './autocomplete.styles';
const Autocomplete = ({ id, label, required, value, options, onChange, placeholder, classes, isWithRenderOption, uiSchema, disabled, showDropdownIcon = true, }) => {
    const uiDisabled = uiSchema['ui:disabled'];
    const isDisabled = disabled || uiDisabled;
    const styles = autocompleteStyles();
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const filterOptions = createFilterOptions({
        matchFrom: 'any',
        limit: 50,
    });
    function handleOnChange(option) {
        if (option) {
            onChange(option.value);
        }
    }
    const inputClasses = {
        root: clsx([classes?.root, styles.root]),
        fieldWrapper: classes?.fieldWrapper,
        errorText: classes?.errorText,
        notchedOutline: classes?.notchedOutline,
        focused: classes?.focused,
        inputError: classes?.inputError,
        helperTextError: classes?.helperTextError,
        dateCalendar: classes?.dateCalendar,
        label: classes?.label,
        phonePrefix: classes?.phonePrefix,
        noOptions: classes?.noOptions,
        inputNoLabel: classes?.inputNoLabel,
        labelContainer: classes?.labelContainer,
        labelAsterisk: classes?.labelAsterisk,
    };
    const defaultValue = useMemo(() => Array.isArray(options?.enumOptions) &&
        options?.enumOptions?.find((option) => option.value === value), [options?.enumOptions, value]);
    return (_jsx(MuiAutocomplete, { disableClearable: true, fullWidth: true, defaultValue: defaultValue, filterOptions: filterOptions, disabled: isDisabled, noOptionsText: String(options?.invalidOption || ''), onChange: (_, option) => handleOnChange(option), open: dropdownOpen, onOpen: () => setDropdownOpen(true), onClose: () => setDropdownOpen(false), classes: {
            input: clsx([classes?.input, styles.input]),
            noOptions: clsx([classes?.noOptions, styles.noOptions]),
            listbox: clsx([classes?.listbox, styles.listbox]),
            fullWidth: classes?.fieldWrapper,
        }, id: id, options: Array.isArray(options?.enumOptions) ? options?.enumOptions : [], getOptionLabel: (option) => {
            if (isWithRenderOption) {
                const separatedLabel = option.label.split('|');
                return separatedLabel[0].trim() || '';
            }
            return option.label;
        }, isOptionEqualToValue: (option, value) => option.value === value.value, "data-test": `autocomplete_input:${id}`, ...(isWithRenderOption && {
            renderOption: (props, option) => {
                const separatedLabel = option.label.split('|');
                const dealerName = separatedLabel[0].trim() || '';
                const city = separatedLabel[1] || '';
                const address = separatedLabel[2] || '';
                return (_jsxs(ListItem, { ...props, className: classes?.dealerContainer, children: [_jsx(Typography, { className: classes?.dealerTitle, children: dealerName }, void 0), _jsx(Typography, { className: classes?.dealerInfo, children: `${city} ${address}` }, void 0)] }, void 0));
            },
        }), renderInput: params => {
            const inputProps = {
                label,
                required,
                id,
                value,
                params,
                placeholder,
                tooltip: options?.tooltip,
                ...(showDropdownIcon && {
                    endAdornment: (_jsx(InputAdornment, { position: "end", disablePointerEvents: isDisabled, className: clsx(styles.endInputAdornment, classes?.endInputAdornment), children: _jsx(KeyboardArrowDownIcon, { onClick: () => setDropdownOpen(prev => !prev), className: clsx([
                                classes?.dropdownIcon,
                                styles.dropdownIcon,
                                {
                                    [styles.dropdownIconOpened]: dropdownOpen,
                                    ...(classes?.dropdownIconOpened && {
                                        [classes.dropdownIconOpened]: dropdownOpen,
                                    }),
                                },
                            ]) }, void 0) }, void 0)),
                }),
            };
            if (options?.displayKeyOnSelect && !dropdownOpen) {
                return (_jsx(GenericInput, { fullWidth: true, classes: inputClasses, disabled: isDisabled, ...inputProps, value: value }, void 0));
            }
            return (_jsx(GenericInput, { fullWidth: true, classes: inputClasses, ...inputProps, disabled: isDisabled }, void 0));
        } }, void 0));
};
export default Autocomplete;
//# sourceMappingURL=Autocomplete.js.map